import { useEffect, useState } from 'react';
import { eventSort } from '../../../components/commonFunc';
import { getEvents } from '../api/api';
import { getEventGraphic2Url, resolveContentMedia } from '../helper/graphic2';
import { HubFeatureCard } from '../layout/HubFeatureCard';
import { HubListingView } from '../layout/HubListingView';
import { useFilteredHubListing } from '../layout/useFilteredHubListing';

function parseEvents(events) {
  return events.map((eItem) => ({
    postId: eItem.id,
    title: eItem.Title,
    postMedia: resolveContentMedia(eItem, getEventGraphic2Url),
    postType: eItem.ContentType,
    postDate: eItem.LastUpdated,
    postName: eItem.Relevance,
    eventStartDate: eItem.StartDate,
    eventEndDate: eItem.EndDate,
    eventUrl: eItem.EventPath,
    addressData: {
      address: eItem.Address,
      country: eItem.Country,
      city: eItem.City,
      state: eItem.State,
      zip: eItem.Zip,
      phone: eItem.Phone,
    },
  }));
}

export function EventCardList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const {
    query,
    hasQuery,
    matchCount,
    firstItem,
    pageItems,
    totalPages,
    currentPage,
    onPageChange,
  } = useFilteredHubListing(items);

  useEffect(() => {
    const loadEvents = async () => {
      setLoading(true);
      try {
        const events = await getEvents();
        setItems(eventSort(parseEvents(events)));
      } catch {
        setItems([]);
      } finally {
        setLoading(false);
      }
    };

    loadEvents();
  }, []);

  const renderFeatured = (item) => <HubFeatureCard firstBlog={item} />;

  return (
    <HubListingView
      title="Events"
      firstItem={firstItem}
      renderFeatured={renderFeatured}
      pageItems={pageItems}
      loading={loading}
      totalPages={totalPages}
      currentPage={currentPage}
      onPageChange={onPageChange}
      hasQuery={hasQuery}
      query={query}
      matchCount={matchCount}
    />
  );
}
